/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Video_Export_Preset_Delete_FailedInputs */

const en_video_export_preset_delete_failed = /** @type {(inputs: Video_Export_Preset_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to delete preset. ${i?.error}`)
};

const fr_video_export_preset_delete_failed = /** @type {(inputs: Video_Export_Preset_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la suppression du prereglage. ${i?.error}`)
};

const de_video_export_preset_delete_failed = /** @type {(inputs: Video_Export_Preset_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voreinstellung konnte nicht gelöscht werden. ${i?.error}`)
};

const it_video_export_preset_delete_failed = /** @type {(inputs: Video_Export_Preset_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile eliminare il preset. ${i?.error}`)
};

const ru_video_export_preset_delete_failed = /** @type {(inputs: Video_Export_Preset_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось удалить предустановку. ${i?.error}`)
};

const es_video_export_preset_delete_failed = /** @type {(inputs: Video_Export_Preset_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar el ajuste preestablecido. ${i?.error}`)
};

const zh_cn2_video_export_preset_delete_failed = /** @type {(inputs: Video_Export_Preset_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除预设失败。${i?.error}`)
};

const ja_video_export_preset_delete_failed = /** @type {(inputs: Video_Export_Preset_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プリセットの削除に失敗しました。${i?.error}`)
};

const hi_video_export_preset_delete_failed = /** @type {(inputs: Video_Export_Preset_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रीसेट को हटाने में विफल। ${i?.error}`)
};

const pt_pt2_video_export_preset_delete_failed = /** @type {(inputs: Video_Export_Preset_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao excluir a predefinição. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to delete preset. {error}" |
*
* @param {Video_Export_Preset_Delete_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preset_delete_failed = /** @type {((inputs: Video_Export_Preset_Delete_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preset_Delete_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_preset_delete_failed(inputs)
	if (locale === "de") return de_video_export_preset_delete_failed(inputs)
	if (locale === "it") return it_video_export_preset_delete_failed(inputs)
	if (locale === "ru") return ru_video_export_preset_delete_failed(inputs)
	if (locale === "es") return es_video_export_preset_delete_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_preset_delete_failed(inputs)
	if (locale === "ja") return ja_video_export_preset_delete_failed(inputs)
	if (locale === "hi") return hi_video_export_preset_delete_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_preset_delete_failed(inputs)
	return en_video_export_preset_delete_failed(inputs)
});